<template>
  <div class="order-item">
    <div class="row no-padding">
      <div class="col-md-4 no-padding order-item__summary">
        <div class="order-item__heading">
          #{{ order.orderNumber }} Ordered {{ formatDate(order.dateOrdered) }}
          <br>
          <span class="order-item__heading-organisation">{{ order.orgName }}</span>
        </div>
        <div class="order-item__details">
          <div class="order-item__col">
            <div v-if="order.orderedBy"
                 class="order-item__sub-heading">
              Ordered by: {{ order.orderedBy }}
            </div>
            <div v-if="order.purchaseOrderNo"
                 class="order-item__sub-heading">
              PO: {{ order.purchaseOrderNo }}
            </div>
            <div class="order-item__cost">
              Total cost: {{ formatPrice(order.totalCost) }}
            </div>
          </div>

          <div class="order-item__col">
            <button
              v-if="order.showRefundOption"
              class="btn btn-sm btn-accent-1 order-item__refund"
              @click="onRefundClick( order.orderHeaderId )">
              Refund
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-8 no-padding">
        <div class="order-item__items">
          <div class="order-item__heading">
            Items in order
          </div>
          <div class="order-item__items-list">
            <div class="row no-padding">
              <div v-for="(item, index) in order.itemsInOrder"
                   :key="index"
                   class="col-md-6 no-padding">
                <order-item-product :name="item.productName"
                                    :cost="item.lineValue"
                                    :status-id="item.statusId"
                                    :status-text="item.statusText"
                                    :credit-order-line-id="item.creditOrderLineId"
                                    :credit-order-id="item.creditOrderId"
                                    :order-header-id="order.orderHeaderId"
                                    @refreshPage="refreshPage">
                </order-item-product>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <OrderRefundsModal
      :show="showOrderRefundsModal"
      :order-id="order.orderHeaderId"
      @close="showOrderRefundsModal = false"
      @refreshPage="refreshPage">
    </OrderRefundsModal>
  </div>
</template>

<script>
import { format } from "date-fns";
import { EcommerceModule } from "spiritweb.packages.ecommerce";
import OrderItemProduct from "~/Components/OrdersHistory/OrderItemProduct.vue";
import OrderRefundsModal from "~/Components/OrdersHistory/OrderRefundsModal.vue";

export default {
  name: "OrderItem",
  components: {
    OrderItemProduct,
    OrderRefundsModal
  },
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ( {
    showOrderRefundsModal: false
  } ),
  methods: {
    formatDate ( input ) {
      return format( new Date( input ), "dd/MM/yyyy" );
    },
    formatPrice ( input ) {
      return EcommerceModule.renderPrice( input, "gbp", "en-gb" );
    },
    onRefundClick () {
      this.showOrderRefundsModal = true;
    },
    refreshPage () {
      this.showOrderRefundsModal = false;
      this.$emit( "refreshPage" );
    }
  }
};
</script>

<style lang="less">
@border-colour: #B2D6D9;

.order-item {
  position: relative;
  padding: 10px;
  margin: 10px 0;
  border: 2px solid @border-colour;
  background-color: #fff;
  font-size: 0.9rem;
  color: #333;

  &__summary {
    position: relative;
  }

  &__view-button {
    margin-top: 10px;
    @media screen and ( min-width: 768px ) {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  &__categories {
    z-index: 100;
    padding: 10px;
    position: absolute;
    top: 0;
    right: 0;
  }

  &__items {
    @media screen and ( max-width: 768px ) {
      margin-top: 15px;
    }

    &-list {
      max-height: 325px;
      overflow-y: auto;
    }
  }

  &__heading {
    font-size: 1.25rem;
    font-weight: 700;

    &-organisation {
      font-size: 0.8em;
      color: #555;
    }
  }

  &__sub-heading {
    color: #999;
  }

  &__cost {
    color: red;
  }

  &__details {
    display: flex;
    justify-content: space-between;

    @media ( min-width: 768px ) {
      flex-direction: column;
    }
  }

  &__refund {
    align-self: flex-end;

    @media ( min-width: 768px ) {
      margin-top: 5px;
    }
  }

  .no-padding {
    padding: 0 !important;
    margin: 0 !important;
  }
}
</style>
